import { defineMessages } from "react-intl";

const messages = defineMessages({
  autoFilledPlaceholder: {
    id: "map.tool.leadFinder.addRecords.fillFieldsStep.autoFilledPlaceholder",
    defaultMessage: "Auto-filled from Lead Finder",
    description: "Auto-filled field placeholder",
  },
  autoFilledValuesCaption: {
    id: "map.tool.leadFinder.addRecords.fillFieldsStep.autoFilledValuesCaption",
    defaultMessage:
      "Values will be filled for all new records. You can edit individual records after creation.",
    description: "Auto filled values caption",
  },
  partiallyFilledCaption: {
    id: "map.tool.leadFinder.addRecords.fillFieldsStep.partiallyFilledCaption",
    defaultMessage: "Value is only applied to leads that don’t already have a {fieldName}",
    description: "Partially filled field caption",
  },
  uniqueCustomFieldRequiredTooltip: {
    id: "map.tool.leadFinder.addRecords.fillFieldsStep.uniqueCustomField.required.tooltip",
    defaultMessage:
      "There is a required field where the value must be unique, so only one lead can be added at a time.",
    description: "Tooltip for send button when a custom field is required and unique",
  },
});

export default messages;
